module.exports = __webpack_public_path__ + "static/fonts/Nunito-ExtraBoldItalic.a9ebb3c.woff";